<template>
    <div class="rating-page">
        <!-- 顶部导航栏 -->
        <header class="header">
            <div class="header-content">
                <img src="@/assets/images/logo.svg" class="logo" alt="" />
                <h1 class="header-title">Chicchi Nails</h1>
            </div>
        </header>

        <div class="container">
            <h2 class="page-title">{{ $it.service_evaluation }}</h2>

            <!-- 服务信息卡片 -->
            <div class="service-info-card" v-for="service in serviceData" :key="service.id">
                <div class="service-info-item">
                    <div class="service-info-label">{{ $it.service_name }}</div>
                    <div class="service-info-value">{{ service.serviceItem.name }}</div>
                </div>
                <div class="service-info-item">
                    <div class="service-info-label">{{ $it.service_category }}</div>
                    <div class="service-info-value">{{ service.serviceItem.serviceCategories.name }}</div>
                </div>
                <div class="service-info-item">
                    <div class="service-info-label">{{ $it.service_staff }}</div>
                    <div class="service-info-value">{{ service.staff.name }}</div>
                </div>
                <div class="service-info-item">
                    <div class="service-info-label">{{ $it.service_price }}</div>
                    <div class="service-info-value">{{ formatPrice(service.serviceItem.price) }}</div>
                </div>
                <div class="service-info-item">
                    <div class="service-info-label">{{ $it.service_time }}</div>
                    <div class="service-info-value">{{ formatDisplayDateTime(service.appointment.serviceTime) }}</div>
                </div>
            </div>

            <!-- 已评价状态卡片 -->
            <div class="reviewed-card" v-if="isReviewed">
                <div class="reviewed-icon">
                    <svg viewBox="0 0 52 52" width="70" height="70">
                        <circle cx="26" cy="26" r="25" fill="none" stroke="#FBC1C0" stroke-width="2"></circle>
                        <path d="M14.1 27.2l7.1 7.2 16.7-16.8" fill="none" stroke="#FBC1C0" stroke-width="3"></path>
                    </svg>
                </div>
                <h3 class="reviewed-message">{{ $it.thank_you_for_your_comment }}</h3>
                <p class="reviewed-thanks">Il tuo feedback è molto importante per noi e continueremo a impegnarci per offrirti un'esperienza di servizio migliore.</p>
            </div>

            <!-- 评价表单 -->
            <div class="review-form-card" v-else>
                <h3 class="form-title">{{ $it.your_evaluation }}</h3>

                <div class="form-group">
                    <label class="form-label required">{{ $it.service_rating }}</label>
                    <div class="rating-container">
                        <el-rate v-model="value" allow-half></el-rate>
                        <span class="error-message" v-show="showRatingError">{{ $it.Please_select_a_review }}</span>
                    </div>
                </div>

                <div class="form-group">
                    <label class="form-label">{{ $it.evaluation_content }}</label>
                    <textarea class="review-textarea" :placeholder="$it.please_input_evaluation" v-model="reviewContent"></textarea>
                </div>

                <button class="submit-button" @click="submitReview">{{ $it.submit_evaluation }}</button>
            </div>
        </div>

        <!-- 成功提示模态框 -->
        <div class="success-modal" :class="{ active: showSuccessModal }">
            <div class="success-modal-content">
                <div class="success-icon">
                    <svg viewBox="0 0 52 52" width="70" height="70">
                        <circle cx="26" cy="26" r="25" fill="none" stroke="#FBC1C0" stroke-width="2"></circle>
                        <path d="M14.1 27.2l7.1 7.2 16.7-16.8" fill="none" stroke="#FBC1C0" stroke-width="3"></path>
                    </svg>
                </div>
                <h3 class="success-title">Valutazione riuscita!</h3>
                <p class="success-message">{{ successMessage }}</p>
                <button class="success-button" @click="openShowModal">Sicuro</button>
            </div>
        </div>

        <!-- 通用消息模态框 -->
        <div class="message-modal" :class="{ active: showMessageModal }">
            <div class="message-modal-content">
                <!-- <div class="message-icon">
          <svg viewBox="0 0 52 52" width="70" height="70">
            <circle cx="26" cy="26" r="25" fill="none" stroke="#FBC1C0" stroke-width="2"></circle>
            <path d="M14.1 27.2l7.1 7.2 16.7-16.8" fill="none" stroke="#FBC1C0" stroke-width="3"></path>
          </svg>
        </div> -->
                <h3 class="message-title">{{ messageTitle }}</h3>
                <p class="message-text">{{ messageText }}</p>
                <button class="message-button" @click="showMessageModal = false">Sicuro</button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import config from '@/config'
import { formatDisplayDateTime, formatPrice } from '@/utils/formatters'
export default {
    name: 'RatingView',
    data: function () {
        return {
            value: 0,
            serviceId: '2',
            openId: null,
            serviceData: [],
            isReviewed: false,
            reviewContent: '',
            showRatingError: false,
            showSuccessModal: false,
            successMessage: 'Grazie per la tua valutazione, continueremo a lavorare sodo per migliorare la qualità del nostro servizio！',
            showMessageModal: false,
            messageTitle: '提示',
            messageText: '消息内容'
        }
    },
    mounted: function () {
        this.openId = this.$route.query.appointmentId
        this.getIsReviewed()
    },
    methods: {
        formatDisplayDateTime: formatDisplayDateTime,
        formatPrice: formatPrice,
        getIsReviewed: function () {
            axios
                .get(`${config.baseURL}api/appointment/open?appointmentId=${this.openId}`, {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        languageCodes: 'it-IT'
                    }
                })
                .then(response => {
                    console.log('预约详情:', response.data)
                    if (response.data.data.rating) {
                        this.isReviewed = true
                    }
                    this.serviceData = response.data.data.appointmentServices
                    // if (response.data && response.data.code === 200) {
                    //   const data = response.data.data;
                    //   this.isReviewed = data.isReviewed;
                    // }
                })
                .catch(error => {
                    console.error('获取预约详情失败:', error)
                })
        },
        openShowModal: function () {
            this.showSuccessModal = false
            this.isReviewed = true
        },
        submitReview: function () {
            // 验证评分是否已选择
            if (this.value === 0) {
                this.showRatingError = true
                return
            }

            // 收集评价数据
            const reviewData = {
                id: this.openId,
                rating: this.value,
                ratingRemark: this.reviewContent.trim()
            }

            // 提交评价到服务器（这里只是模拟）
            console.log('提交评价数据:', reviewData)
            axios
                .put(`${config.baseURL}api/appointment/open/rating`, reviewData)
                .then(response => {
                    console.log('提交评价成功:', response.data)
                    this.showSuccessModal = true
                })
                .catch(error => {
                    console.error('提交评价失败:', error)
                    this.showMessage('提交评价失败', '提示')
                })

            // 显示成功消息
        },

        showMessage: function (message, title) {
            this.messageTitle = title || '提示'
            this.messageText = message
            this.showMessageModal = true
        }
    }
}
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Microsoft YaHei', 'Helvetica Neue', Arial, sans-serif;
}

.rating-page {
    background-color: #f9f9f9;
    min-height: 100vh;
}

.container {
    max-width: 700px;
    margin: 0 auto;
    padding: 0 15px;
}

/* 顶部导航样式 */
.header {
    background-color: #fff;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    padding: 15px 0;
    position: sticky;
    top: 0;
    z-index: 100;
}

.header-content {
    display: flex;
    align-items: center;
    max-width: 700px;
    margin: 0 auto;
    padding: 0 15px;
}

.logo {
    height: 40px;
    margin-right: 15px;
}

.header-title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
}

/* 页面标题样式 */
.page-title {
    text-align: center;
    margin: 25px 0 20px;
    color: #333;
    font-size: 22px;
    font-weight: bold;
}

/* 服务信息区域 */
.service-info-card {
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    padding: 20px;
    margin-bottom: 20px;
}

.service-info-item {
    display: flex;
    padding: 12px 0;
    border-bottom: 1px dashed #eee;
}

.service-info-item:last-child {
    border-bottom: none;
}

.service-info-label {
    width: 160px;
    color: #888;
    font-size: 15px;
}

.service-info-value {
    flex: 1;
    color: #333;
    font-size: 15px;
    font-weight: 500;
}

/* 评价表单区域 */
.review-form-card {
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    padding: 20px;
    margin-bottom: 20px;
}

/* 已评价状态卡片 */
.reviewed-card {
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    padding: 30px 20px;
    margin-bottom: 20px;
    text-align: center;
}

.reviewed-icon {
    width: 70px;
    height: 70px;
    margin: 0 auto 20px;
}

.reviewed-message {
    font-size: 18px;
    color: #333;
    margin-bottom: 15px;
}

.reviewed-thanks {
    font-size: 16px;
    color: #666;
    line-height: 1.6;
}

.form-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
    color: #333;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
}

.form-group {
    margin-bottom: 20px;
}

.form-label {
    display: block;
    margin-bottom: 10px;
    font-size: 16px;
    color: #333;
}

.required:after {
    content: '*';
    color: #e74c3c;
    margin-left: 5px;
}

/* 星级评分样式 */
.rating-container {
    display: flex;
    flex-direction: column;
}

.stars-container {
    display: flex;
    margin-bottom: 5px;
}

.star {
    font-size: 30px;
    margin-right: 10px;
    color: #ddd;
    cursor: pointer;
    transition: all 0.2s;
}

.star.active {
    color: #fbc1c0;
}

.star:hover {
    transform: scale(1.2);
}

.rating-text {
    margin-top: 10px;
    font-size: 14px;
    color: #777;
}

.error-message {
    color: #e74c3c;
    font-size: 14px;
    margin-top: 5px;
}

/* 评价内容文本框 */
.review-textarea {
    width: 100%;
    height: 120px;
    padding: 12px 15px;
    border: 1px solid #ddd;
    border-radius: 8px;
    resize: none;
    font-size: 15px;
    transition: border-color 0.3s;
}

.review-textarea:focus {
    outline: none;
    border-color: #fbc1c0;
}

/* 提交按钮 */
.submit-button {
    display: block;
    width: 100%;
    padding: 12px 0;
    background-color: #fbc1c0;
    color: white;
    border: none;
    border-radius: 25px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s, transform 0.2s;
    box-shadow: 0 3px 10px rgba(251, 193, 192, 0.3);
}

.submit-button:hover {
    background-color: #f9adab;
    transform: translateY(-2px);
}

.submit-button:active {
    transform: translateY(0);
}

/* 成功模态框 */
.success-modal {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 2000;
    overflow: auto;
}

.success-modal.active {
    display: flex;
    justify-content: center;
    align-items: center;
}

.success-modal-content {
    background-color: #fff;
    width: 80%;
    max-width: 400px;
    border-radius: 12px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
    padding: 30px 20px;
    text-align: center;
    animation: modalBounceIn 0.5s;
}

@keyframes modalBounceIn {
    0% {
        transform: scale(0.8);
        opacity: 0;
    }
    50% {
        transform: scale(1.05);
    }
    100% {
        transform: scale(1);
        opacity: 1;
    }
}

.success-icon {
    margin: 0 auto 20px;
    width: 70px;
    height: 70px;
    animation: iconScale 0.5s 0.3s both;
}

@keyframes iconScale {
    0% {
        transform: scale(0);
    }
    50% {
        transform: scale(1.2);
    }
    100% {
        transform: scale(1);
    }
}

.success-icon svg path {
    stroke-dasharray: 100;
    stroke-dashoffset: 100;
    animation: dash 1s 0.6s forwards;
}

@keyframes dash {
    to {
        stroke-dashoffset: 0;
    }
}

.success-title {
    font-size: 24px;
    color: #333;
    margin-bottom: 15px;
}

.success-message {
    font-size: 16px;
    color: #666;
    margin-bottom: 25px;
    line-height: 1.5;
}

.success-button {
    background-color: #fbc1c0;
    color: white;
    border: none;
    padding: 12px 30px;
    font-size: 16px;
    border-radius: 30px;
    cursor: pointer;
    font-weight: bold;
    transition: background-color 0.3s, transform 0.2s;
    box-shadow: 0 3px 10px rgba(251, 193, 192, 0.3);
}

.success-button:hover {
    background-color: #f9adab;
    transform: translateY(-2px);
}

.success-button:active {
    transform: translateY(0);
}

/* 通用消息模态框样式 */
.message-modal {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
}

.message-modal.active {
    display: flex;
    justify-content: center;
    align-items: center;
}

.message-modal-content {
    background-color: white;
    border-radius: 15px;
    padding: 25px;
    width: 85%;
    max-width: 350px;
    text-align: center;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
    animation: modalBounceIn 0.4s;
}

.message-icon {
    margin: 0 auto 15px;
    width: 50px;
    height: 50px;
}

.message-title {
    font-size: 20px;
    color: #333;
    margin-bottom: 10px;
}

.message-text {
    font-size: 16px;
    color: #666;
    margin-bottom: 20px;
    line-height: 1.4;
}

.message-button {
    background-color: #fbc1c0;
    color: white;
    border: none;
    padding: 10px 25px;
    font-size: 16px;
    border-radius: 25px;
    cursor: pointer;
    font-weight: bold;
    transition: background-color 0.3s;
}

.message-button:hover {
    background-color: #f9adab;
}
</style>
